import storage from '../services/storage';
import { contactService } from '../services/contactService';
import { taskService } from '../services/taskService';
import { meetingService } from '../services/meetingService';
import { pipelineService } from '../services/pipelineService';
import { automationService } from '../services/automationService';
import { auditService } from '../services/auditService';
import { trashService } from '../services/trashService';
import { notificationService } from '../services/notificationService';
import { LEADS, LISTS, DEMO_LEADS, DEMO_TASKS, DEMO_MEETINGS } from '../data/leads';
import { migratePrivateBucketsToTeam, ensureBuiltinLists } from './teamCrmStore';

/**
 * Lädt CRM-State aus localStorage in React-Setter (nach Login/Hydrate).
 */
export function loadUserDataIntoState(user, setters) {
  const {
    setLeads,
    setLists,
    setTasks,
    setMeetings,
    setPipelineStages,
    setAutomations,
    setAuditLog,
    setTrash,
    setNotifications,
  } = setters;

  const isDemo = user.role === 'demo';
  migratePrivateBucketsToTeam();

  const storedLeads = contactService.getAll();
  const finalLeads = storedLeads.length > 0 ? storedLeads : (isDemo ? [...DEMO_LEADS] : []);
  setLeads(finalLeads);

  const storedLists = storage.get('crm_lists', null);
  setLists(ensureBuiltinLists(storedLists || (isDemo ? [] : []), finalLeads));

  const storedTasks = taskService.getAll();
  setTasks(storedTasks.length > 0 ? storedTasks : (isDemo ? [...DEMO_TASKS] : []));

  const storedMeetings = meetingService.getAll();
  setMeetings(storedMeetings.length > 0 ? storedMeetings : (isDemo ? [...DEMO_MEETINGS] : []));

  setPipelineStages(pipelineService.get());
  setAutomations(automationService.getAll(user.id));
  setAuditLog(auditService.getAll(user.id));
  setTrash(trashService.getAll(user.id));
  setNotifications(notificationService.getAll(user.id));
}
